<li
  [class.child]="isChild"
  [class.list]="!icon"
  [class.disabled]="disabled"
  [routerLink]="disabled ? null : (link ?? title.toLowerCase())"
  [routerLinkActive]="disabled ? '' : 'activeRoute'"
  [routerLinkActiveOptions]="exact ? exactMatchOptions : { exact: false }"
  tabindex="-1"
>
  <a
    class="d-flex justify-content-between align-items-center"
    [routerLink]="disabled ? null : (link ?? title.toLowerCase())"
    [attr.tabindex]="disabled ? 0 : visible ? 0 : -1"
    [attr.aria-disabled]="disabled"
    [title]="title"
    (click)="onClick($event)"
    (keydown)="onKeydown($event)"
  >
    <span class="d-flex align-items-center">
      <i
        class="bi"
        [class]="icon"
        [style.marginRight.rem]="offset ? -offset : undefined"
        [style.marginLeft.rem]="offset"
      >
        @if (count && count > 0) {
          <span
            class="position-absolute top-0 start-100 translate-middle badge bg-danger"
            style="font-size: 0.7em; padding: 0.2em 0.6em; margin-left: -0.5em"
            >{{ count }}</span
          >
        }
      </i>
      <span class="title ps-3">
        {{ title }}
      </span>
    </span>
    <span class="d-flex flex-column align-items-end gap-1">
      @if (new) {
        <span class="badge bg-primary">Nieuw</span>
      }
      @if (beta) {
        <span class="badge bg-danger">Beta</span>
      }
    </span>
  </a>
</li>
